import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { OwnerCreateRequestBody, OwnerCreateResponse } from "./types";

export class OwnerCreateAPI extends BaseAPI<
    OwnerCreateRequestBody,
    OwnerCreateResponse
> {
    protected route = ApiRoutes.owner.create;
    protected method = RequestMethod.POST;
}
